export default __webpack_public_path__ + "static/media/pic1.11683e7e.png";